import apiClient from 'helpers/api-client';
import eventEmitter from 'helpers/event-emitter';
import { EVENT_ADD_WAITING_ASSET } from 'constants/events';
import Steven from 'helpers/steven';

const API_ORIGIN_EXTERNAL = 'external';

const createVideoForProject =
  (videoURI, projectId, duration) => async (_, getState) => {
    const state = getState();
    const user = state.user;
    const path = `locations/${projectId}/videos`;
    const videoData = {
      uri: videoURI,
      capture_date: new Date().toISOString(),
      duration,
      origin: API_ORIGIN_EXTERNAL,
    };
    const apiData = await apiClient.post(path, { video: videoData });

    eventEmitter.trigger(EVENT_ADD_WAITING_ASSET, {
      asset_v1_id: apiData.id,
      user_id: user.id,
      location_id: projectId,
    });

    const stevenData = {
      captured_asset_id: `${apiData.id}`,
      captured_asset_type: 'video',
      duration_seconds: duration,
    };

    Steven.uploadAction(stevenData);

    return apiData;
  };

export { createVideoForProject };
